import {gateway} from '../utils/api'

export const fetchOnboardingPages = async () => {
  const response = await gateway.get('/onboarding/steps').catch(() => {
    return [];
  });

  if (!Array.isArray(response) || response.length === 0) {
    return [];
  }

  return response;
}

export const saveOnboardingSteps = async (data) => {
  const url = "/onboarding/steps"
  return gateway.post(url, data)
}

export const fetchSelectType = async (group, text = '') => {
  return gateway.get(`onboarding/select-options?group=${group}&text=${text}`)
}